class Utils {
  setStorage(storage, storageKey, value) {
    window[storage] && window[storage].setItem(storageKey, value)
  }

  getStorage(storage, key) {
    return window[storage] && window[storage].getItem(key)
  }

  concatSearch(params = {}) {
    let str = '?'
    for (let key in params) {
      str += `${key}=${params[key]}&`
    }
    const len = str.length - 1
    return len > 0 ? str.substr(0, len) : str.substr(0)
  }

  getQueryString(name, str) {
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    const r = str ? str.match(reg) : this._getSearch().match(reg)
    if (r != null) {
      return unescape(r[2])
    }
    return null
  }
  _getSearch() {
    const href = window.location.href
    const index = href.indexOf('?')
    return index >= 0 ? href.substr(index + 1) : ''
  }
  parseQuery() {
    let search = this._getSearch()
    if (!search) {
      return false
    }
    let reg = /([^&=\s]+)[=\s]?([^&=\s]*)/g
    let obj = {}
    while (reg.exec(search)) {
      let key = RegExp.$1
      let value = RegExp.$2
      if (obj.hasOwnProperty(key) && value !== '') {
        obj[key] = [obj[key], value]
        continue
      }
      obj[key] = value
    }
    return obj
  }
  isApp() {
    let from = this.getQueryString('from')
    if (!from) {
      return false
    }
    return from.indexOf('app') > -1
  }
}

export default new Utils()

export function formatDate(date, fmt = 'yyyy-MM-dd hh:mm:ss') {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str))
    }
  }
  return fmt
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length)
}

export function toDecimal2(n) {
  if (typeof n === 'number' || typeof n === 'string') {
    const str = (Math.round(n * 100) / 100).toString()
    const index = str.indexOf('.')
    if (index === -1) {
      return str + '.00'
    }
    const result = str.substr(0, index + 1)
    return str.length - (index + 1) >= 2 ? result + str.substr(index + 1, 2) : result + str.substr(index + 1) + '0'
  }
  console.error('参数n的类型 只能是number或string')
  return -1
}

export function unescapeHTML(str) {
  let html = '' + str
  return html
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, '&')
    .replace(/&quot;/g, '"')
    .replace(/&apos;/g, "'")
}

export function is_weixn() {
  const ua = navigator.userAgent.toLowerCase()
  return ua.match(/MicroMessenger/i) == 'micromessenger'
}
export function is_qq() {
  const ua = navigator.userAgent.toLowerCase()
  return ua.indexOf(' qq') > -1 && ua.indexOf('mqqbrowser') < 0
}

export const JudgeBrowser = (function() {
  //flag为1是ios，flag为2是安卓
  //wx为1表示在微信中打开了页面，wx为2表示否
  let flag, wx
  const ua = navigator.userAgent
  flag = ua.indexOf('iPhone') > -1 || ua.indexOf('iPad') > -1 ? 1 : 2
  wx = ua.toLowerCase().match(/MicroMessenger/i) == 'micromessenger' ? 1 : 2
  return { flag, wx }
})()
export function appconnect(options) {
  var defaults = {
    action: 1,
    title: '',
    content: '',
    url: '',
    channel: '',
    imgUrl: ''
  }

  var opts = Object.assign(defaults, options)
  var oAction = opts.action
  var oTitle = opts.title
  var oContent = opts.content
  var oUrl = opts.url
  var imgUrl = opts.imgUrl
  var BigUrl
  var Scontent = ''

  var getFlag = JudgeBrowser
  var flag = getFlag.flag
  if (flag == 1) {
    oUrl = oUrl.replace('?', '!').replace('=', '-')
  }
  if (oAction == 1 || oAction == 3) {
    Scontent = '&title=' + oTitle + '&content=' + oContent + '&imgUrl=' + imgUrl + '&url=' + oUrl
    BigUrl = 'hqb://location?action=' + oAction + Scontent
  } else {
    BigUrl = 'hqb://location?action=' + oAction
  }
  if (flag == 1) {
    window.location.href = BigUrl
  } else {
    window.WebJavascript.clickCenter(oAction, Scontent)
  }
}